export default "__VITE_ASSET__BbmeW8zh__"